(() => {
  function initialize(root) {
  if (!root || root._paperCleanup) return;
  const controller = new AbortController();
  const on = (target, type, handler, options = {}) => target.addEventListener(type, handler, { ...options, signal: controller.signal });
  const observers = [];
  const observe = (callback, element) => { const observer = new ResizeObserver(callback); observer.observe(element); observers.push(observer); };
  const $ = selector => root.querySelector(selector);
  const $$ = selector => [...root.querySelectorAll(selector)];
  const papers = JSON.parse($('#bp-paper-data').textContent);
  const rows = new Map(papers.map(p => [p.id, $(`#paper-${p.id}`)]));
  const notes = JSON.parse($('#bp-guidance-data').textContent);
  const groups = Object.fromEntries(Object.entries(notes).map(([key,note]) => [key, { ids: papers.filter(p => p[key]).map(p => p.id), note }]));

  const state = { work: '', focus: null, selected: new Set() };
  const escape = value => String(value).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  function filterPapers() {
    const query = $('#bp-search').value.toLowerCase().trim();
    const finish = $('#bp-finish').value;
    const texture = $('#bp-texture').value;
    const brand = $('#bp-brand').value;
    
    return papers.filter(p => (!state.work || groups[state.work].ids.includes(p.id)) &&
      (!query || `${p.name} ${p.desc} ${p.best}`.toLowerCase().includes(query)) &&
      (!finish || p.finish === finish) && (!texture || p.texture === texture) && (!brand || p.brand === brand))
      .sort((a, b) => root.dataset.paperOrder === 'name' ? a.name.localeCompare(b.name) : a.id - b.id);
  }
  let lastResults = '';
  function render() {
    const railScroll = $('#pg-paper-list').scrollTop;
    const list = filterPapers();
    const visible = list;
    const resultsKey = list.map(p => p.id).join(',');
    const resultsChanged = resultsKey !== lastResults;
    lastResults = resultsKey;
    if (!visible.some(p => p.id === state.focus)) state.focus = visible[0]?.id ?? null;
    const visibleIds = new Set(visible.map(p => p.id));
    papers.forEach(p => { rows.get(p.id).hidden = p.id !== state.focus; });
    $$('[data-focus]').forEach(button => {
      const id = Number(button.dataset.focus);
      button.closest('[data-choice]').hidden = !visibleIds.has(id);
      button.setAttribute('aria-pressed', String(id === state.focus));
      button.querySelector('.pg-viewing').hidden = id !== state.focus;
    });
    // Keep the same button nodes so keyboard focus survives selection changes.
    const activeElement = document.activeElement;
    if (resultsChanged) list.forEach(p => $('#pg-paper-list').append($(`[data-choice="${p.id}"]`))); 
    $('#pg-paper-list').scrollTop = resultsChanged ? 0 : railScroll;
    if (activeElement && root.contains(activeElement) && !activeElement.closest('[hidden]')) activeElement.focus({ preventScroll: true });
    $('#bp-count').textContent = `${visible.length} of ${papers.length} papers · Choose one to explore`;
    $('#bp-guidance-text').hidden = !state.work;
    $('#bp-guidance-text').textContent = state.work ? groups[state.work].note : '';
    $('#bp-empty').hidden = list.length !== 0;
    $('.pg-focus').hidden = list.length === 0;
    updateDockVisibility();
  }
  function comparison() {
    const chosen = [...state.selected].map(id => papers.find(p => p.id === id));
    const fields = [['finish', 'Finish'], ['texture', 'Texture'], ['tone', 'Paper white'], ['weight', 'Weight'], ['thickness', 'Thickness'], ['material', 'Material / coating'], ['best', 'Best for']]
      .filter(([key]) => !$('#bp-differences').checked || new Set(chosen.map(p => p[key])).size > 1);
    $('#bp-comparison').classList.toggle('two', chosen.length === 2);
    $('#bp-comparison').style.setProperty('--pg-comparison-rows', fields.length + 2);
    $('#bp-comparison').innerHTML = chosen.map(p => `<div class="bp-comp-item"><div class="pg-comparison-identity"><div class="bp-paper-brand">${escape(p.brand)}</div><h4>${escape(p.short)}</h4></div><button class="bp-remove-paper" data-remove="${p.id}" aria-label="Remove ${escape(p.name)} from comparison">Remove paper</button>${fields.map(([key, label]) => `<div class="bp-comp-fact" data-field="${key}"><small>${label}</small>${escape(p[key])}</div>`).join('')}</div>`).join('');
  }
  const dialog = $('#bp-compare');
  const dock = $('.pg-compare-dock');
  observe(entries => {
    dialog.style.setProperty('--pg-dialog-header-height', `${entries[0].target.getBoundingClientRect().height}px`);
  }, $('.pg-dialog-header'));
  let previousOverflow = '';
  let returnFocus = null;
  function updateDockVisibility() {
    const paperArea = $('.pg-focus');
    const rect = paperArea.getBoundingClientRect();
    const header = document.querySelector('.header__sticky.sticky, sticky-header, .header-sticky, .sticky-header, .dev-header');
    const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    const perspective = document.querySelector('#bo-paper-library .pg-perspective');
    const perspectiveTop = perspective ? perspective.getBoundingClientRect().top : Infinity;
    // Allow 400px of the following editorial section into view before dropping the tray.
    dock.hidden = dialog.open || paperArea.hidden || rect.top >= window.innerHeight ||
      rect.bottom <= headerBottom || perspectiveTop < window.innerHeight - Number(root.dataset.trayAllowance || 400);
  }
  function closeComparison() { if (dialog.open) dialog.close(); }
  on(dialog, 'close', () => {
    document.body.style.overflow = previousOverflow;
    updateDockVisibility();
    if (returnFocus && returnFocus.isConnected) {
      const target = returnFocus.disabled ? ($('.pg-paper-choice:not([hidden]) input') || $('#bp-work')) : returnFocus;
      target.focus({ preventScroll: true });
    }
  });
  function renderTray() {
    const chosen = [...state.selected].map(id => papers.find(p => p.id === id));
    $('#bp-selected-count').textContent = chosen.length ? `${chosen.length} of 3 papers selected` : 'Compare your papers';
    $('#bp-selected-names').innerHTML = chosen.length ? chosen.map(p => `<button class="pg-selection-chip" data-remove="${p.id}" aria-label="Remove ${escape(p.name)} from comparison">${escape(p.short)}<span aria-hidden="true">×</span></button>`).join('') : 'Choose two or three papers using the Compare checkboxes.';
    $('#bp-compare-open').disabled = chosen.length < 2;
    $('#bp-compare-open').textContent = chosen.length > 1 ? `Compare ${chosen.length} papers` : chosen.length ? 'Select one more paper' : 'Compare papers';
    $('#bp-clear-shortlist').hidden = chosen.length === 0;
    $$('[data-compare]').forEach(input => { input.checked = state.selected.has(Number(input.dataset.compare)); });
    if (chosen.length < 2) closeComparison();
    comparison();
    updateDockVisibility();
  }
  on(window, 'scroll', updateDockVisibility, { passive: true });
  on(window, 'resize', updateDockVisibility);
  observe(() => {
    if (!dock.hidden) root.style.setProperty('--pg-dock-height', `${dock.offsetHeight + 25}px`);
  }, dock);
  function clearFilters() {
    state.work = '';
    ['#bp-work', '#bp-search', '#bp-finish', '#bp-texture', '#bp-brand'].forEach(selector => { $(selector).value = ''; });
    render();
  }
  $('.pg-focus').classList.add('is-enhanced');
  ['.pg-guide-fields', '.pg-shortlist', '.pg-search-tools'].forEach(selector => { $(selector).hidden = false; });
  $$('.pg-article .bp-compare-label').forEach(label => { label.hidden = false; });
  $('#bp-selected-count').setAttribute('aria-live', 'polite');
  on($('#bp-work'), 'change', event => {
    state.work = event.target.value;
    $('#bp-search').value = '';
    render();
  });
  on($('#pg-reset-filters'), 'click', clearFilters);
  on($('#bp-search'), 'input', () => {
    // Name searches cover the collection rather than a previous artwork shortlist.
    state.work = ''; $('#bp-work').value = ''; render();
  });
  ['#bp-finish', '#bp-texture', '#bp-brand'].forEach(selector => on($(selector), 'change', render));
  on($('#pg-paper-list'), 'click', event => {
    const button = event.target.closest('[data-focus]');
    if (!button) return;
    state.focus = Number(button.dataset.focus); render();
    if (window.matchMedia('(max-width:700px)').matches) {
      rows.get(state.focus).scrollIntoView({ block: 'start' });
    }
  });
  on(root, 'change', event => {
    if (!event.target.matches('[data-compare]')) return;
    const id = Number(event.target.dataset.compare);
    $('#bp-error').textContent = '';
    if (event.target.checked) {
      if (state.selected.size === 3) {
        event.target.checked = false;
        $('#bp-error').textContent = 'Choose up to three papers. Uncheck one to add another.';
        
        return;
      }
      state.selected.add(id);
    } else state.selected.delete(id);
    renderTray();
  });
  on(root, 'click', event => {
    const button = event.target.closest('[data-remove]');
    if (!button) return;
    const wasOpen = dialog.open;
    state.selected.delete(Number(button.dataset.remove));
    $('#bp-error').textContent = '';
    renderTray();
    if (dialog.open) $('#bp-compare-close').focus({ preventScroll: true });
    else if (!wasOpen) {
      const next = $('#bp-selected-names button') || $('.pg-paper-choice:not([hidden]) input');
      next?.focus({ preventScroll: true });
    }
  });
  on($('#bp-clear-shortlist'), 'click', () => {
    state.selected.clear(); $('#bp-error').textContent = ''; renderTray();
    $('.pg-paper-choice:not([hidden]) input')?.focus({ preventScroll: true });
  });
  on($('#bp-compare-open'), 'click', () => {
    if (state.selected.size < 2) return;
    returnFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    comparison();
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    dock.hidden = true;
    $('#bp-compare-close').focus({ preventScroll: true });
  });
  on($('#bp-compare-close'), 'click', closeComparison);
  on(dialog, 'click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeComparison();
  });
  on(dialog.querySelector('a[href="#bp-samples"]'), 'click', () => { returnFocus = null; closeComparison(); });
  on($('#bp-differences'), 'change', comparison);
  on(root, 'shopify:block:select', event => {
    const article = root.querySelector(`[data-block-id="${event.detail.blockId}"]`);
    if (!article) return;
    clearFilters(); state.focus = Number(article.id.replace('paper-', '')); render();
    article.scrollIntoView({ block: 'nearest' });
  });
  root._paperCleanup = () => { closeComparison(); controller.abort(); observers.forEach(observer => observer.disconnect()); delete root._paperCleanup; };
  render(); renderTray();
  }
  const init = () => document.querySelectorAll('#bo-paper-library [data-paper-guide]').forEach(initialize);
  if (!window.boPaperGuideRegistered) {
    window.boPaperGuideRegistered = true;
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-paper-guide]').forEach(root => root._paperCleanup?.()));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  }
  init();
})();
